import { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Spin,
  Input,
  Tag,
  Card,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { postAPI } from "../../utils/common"; // tumhara existing api util
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Layout } from "antd";
import { VENDOR_BILL_DISCOUNT_LOGS } from "../../constants/api";
import dayjs from "dayjs";

function DiscountLogs() {
  const { Content } = Layout;

  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = () => {
    setLoading(true);
    postAPI(
      VENDOR_BILL_DISCOUNT_LOGS,
      {},
      (res) => {
        if (res.status) {
          const rows = res.data.map((log) => ({
            key: log.id,
            ...log,
          }));
          setLogs(rows);
          setFilteredLogs(rows);
        }
        setLoading(false);
      },
      () => setLoading(false),
    );
  };

  const handleSearch = (value) => {
    const search = value.toLowerCase().trim();
    setSearchText(value);
    if (!search) {
      setFilteredLogs(logs);
      return;
    }
    setFilteredLogs(
      logs.filter((item) =>
        Object.values(item).some(
          (val) =>
            val &&
            typeof val === "string" &&
            val.toLowerCase().includes(search),
        ),
      ),
    );
  };

  const columns = [
    { title: "ID", dataIndex: "id" },
    { title: "Bill ID", dataIndex: "vendor_bill_id" },
    { title: "Discount Code", dataIndex: "discount_code" },
    { title: "Discount Amount", dataIndex: "discount_amount" },
    {
      title: "Action",
      dataIndex: "action",
      render: (action) => {
        return <Tag color="green">{action.toUpperCase()}</Tag>;
      },
    },
    { title: "Remark", dataIndex: "remark" },
    {
      title: "Action By",
      dataIndex: "action_by",
      render: (action_by) => action_by.name,
    },
    {
      title: "Issue Date",
      dataIndex: "updated_at",
      render: (updated_at) => dayjs(updated_at).format("YYYY-MM-DD"),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Discount Logs"
          extra={
            <Space>
              <Input
                placeholder="Search logs..."
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 200 }}
              />
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                onClick={fetchLogs}
              >
                Reload
              </Button>
            </Space>
          }
        >
          <Spin spinning={loading}>
            <Table
              columns={columns}
              dataSource={filteredLogs}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 1000 }}
            />
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default DiscountLogs;
